import Populator from './populator.js';

export default class LocalStoragePopulator extends Populator {

    populate() {
        const key = this.input.el.dataset.localStorage;
        const value = localStorage.getItem(key);        
        if (value) {
            super.populate(value);
        }        
    }

    static applies(input) {
        return input.el.dataset.localStorage !== undefined;
    }
}
